import React from 'react';
import styles from './ExperienceItem.module.css';

/**
 * Experience Item Component - displays a single experience/achievement card
 */
function ExperienceItem({ icon, label, title, description }) {
  return (
    <div className={styles.item}>
      <div className={styles.iconWrapper}>
        {icon}
      </div>
      <div className={styles.content}>
        <div className={styles.label}>{label}</div>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

export default ExperienceItem;
